/*
 * @Descripttion: 咸亨公告页面reducer
 * @Author: 曹博
 * @Date: 2023-10-16 14:55:36
 * @LastEditors: 曹博
 * @LastEditTime: 2023-10-16 14:59:17
 */
import { ActionType, CustomAction } from '../../global'

export interface State {
  dataSource: {
    data: any[]
    total: number
  }
  loading: boolean
  searchData: any
  pages: {
    pageNo: number
    pageSize: number
  }
}

export const initState: State = {
  dataSource: {
    data: [],
    total: 100,
  },
  loading: true,
  searchData: {},
  pages: {
    pageNo: 1,
    pageSize: 10,
  },
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      newstate.dataSource = action.payload.dataSource
      newstate.pages.pageNo = action.payload.pageNo
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setPagesAction':
      newstate.pages = action.payload
      return newstate
    case 'setSearchDataAction':
      // 搜索 重置 分页
      newstate.searchData = action.payload
      newstate.pages.pageNo = 1
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置表格数据
 * @param param
 * @returns
 */
export const setDataSourceAction = (param: {
  dataSource: {
    data: any[]
    total: number
  }
  pageNo: number
}): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 页面loading
export const setLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setLoadingAction',
  payload: val,
})

// 切换分页
export const setPagesAction = (param: {
  pageNo: number
  pageSize?: number
}): CustomAction<Action> => ({
  type: 'setPagesAction',
  payload: param,
})

// 搜索
export const setSearchDataAction = (param: any): CustomAction<Action> => ({
  type: 'setSearchDataAction',
  payload: param,
})
/*
 * @Descripttion: 咸亨公告页面reducer
 * @Author: 曹博
 * @Date: 2023-10-16 14:55:36
 * @LastEditors: 曹博
 * @LastEditTime: 2023-10-16 14:59:17
 */
import { ActionType, CustomAction } from '../../global'

export interface State {
  dataSource: {
    data: any[]
    total: number
  }
  loading: boolean
  searchData: any
  pages: {
    pageNo: number
    pageSize: number
  }
}

export const initState: State = {
  dataSource: {
    data: [],
    total: 100,
  },
  loading: true,
  searchData: {},
  pages: {
    pageNo: 1,
    pageSize: 10,
  },
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      newstate.dataSource = action.payload.dataSource
      newstate.pages.pageNo = action.payload.pageNo
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setPagesAction':
      newstate.pages = action.payload
      return newstate
    case 'setSearchDataAction':
      // 搜索 重置 分页
      newstate.searchData = action.payload
      newstate.pages.pageNo = 1
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置表格数据
 * @param param
 * @returns
 */
export const setDataSourceAction = (param: {
  dataSource: {
    data: any[]
    total: number
  }
  pageNo: number
}): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 页面loading
export const setLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setLoadingAction',
  payload: val,
})

// 切换分页
export const setPagesAction = (param: {
  pageNo: number
  pageSize?: number
}): CustomAction<Action> => ({
  type: 'setPagesAction',
  payload: param,
})

// 搜索
export const setSearchDataAction = (param: any): CustomAction<Action> => ({
  type: 'setSearchDataAction',
  payload: param,
})
